<aside id="sidebar" (mouseenter)="onMouseEnter()" (mouseleave)="onMouseLeave()">
  <header class="border-bottom">
    <div class="logo">
      <figure class="m-0">
        <img src="./assets/images/logo.png" alt="" width="50px" height="50px" />
      </figure>
    </div>
    <h5 class="title w-100 m-0 d-flex flex-column align-items-start gap-0">
      <span class="d-block fs-4">TramiFast</span>
      <span style="font-size: 10px">v{{ version }}</span>
    </h5>
  </header>

  <main>
    <nav class="mb-4">
      <ul class="nav-menu list-unstyled m-0">
        <li class="nav-item">
          <a routerLink="/home" routerLinkActive="active" [routerLinkActiveOptions]="{ exact: true }" class="nav-link" (click)="actionsOnResponsiveMobile()">
            <i class="nav-icon bi bi-house"></i>
            <span class="nav-text">Inicio</span>
          </a>
        </li>
      </ul>
    </nav>

    <nav *showForPermissions="['user_create']" class="mb-4">
      <p class="nav-title mb-2">Sistema</p>

      <ul class="nav-menu list-unstyled m-0">
        <li *showForPermissions="['user_create']" class="nav-item">
          <a routerLink="/user" routerLinkActive="active" [routerLinkActiveOptions]="{ exact: true }" class="nav-link" (click)="actionsOnResponsiveMobile()">
            <i class="nav-icon bi bi-person"></i>
            <span class="nav-text">Usuarios</span>
          </a>
        </li>
        <li *showForRoles="['GESTOR']" class="nav-item">
          <a routerLink="/setting/platform/robots" routerLinkActive="active" [routerLinkActiveOptions]="{ exact: true }" class="nav-link" (click)="actionsOnResponsiveMobile()">
            <i class="nav-icon bi bi-sliders"></i>
            <span class="nav-text">Configuraciones</span>
          </a>
        </li>
      </ul>
    </nav>

    <nav *showForPermissions="['report_access']" class="mb-4">
      <p class="nav-title mb-2">Reportes</p>

      <ul class="nav-menu list-unstyled m-0">
        <li class="nav-item">
          <a routerLink="/report" routerLinkActive="active" [routerLinkActiveOptions]="{ exact: true }" class="nav-link" (click)="actionsOnResponsiveMobile()">
            <i class="nav-icon bi bi-file-bar-graph"></i>
            <span class="nav-text">Reporte personal</span>
          </a>
        </li>
        <li *showForPermissions="['user_create', 'report_clients']" class="nav-item">
          <a routerLink="/report/network" routerLinkActive="active" [routerLinkActiveOptions]="{ exact: true }" class="nav-link" (click)="actionsOnResponsiveMobile()">
            <i class="nav-icon bi bi-file-bar-graph"></i>
            <span class="nav-text">Reportes de clientes</span>
          </a>
        </li>
      </ul>
    </nav>

    <!-- <nav *showForPermissions="['antecedente_no_penal_access', 'antecedente_no_inhabilitacion_access', 'antecedente_federal_access']" class="mb-4">
      <p class="nav-title mb-2">Antecedentes</p>

      <ul class="nav-menu list-unstyled m-0">
        <li *showForPermissions="['antecedente_no_penal_access']" class="nav-item">
          <a routerLink="/antecedente/no-penal" routerLinkActive="active" [routerLinkActiveOptions]="{ exact: true }" class="nav-link" (click)="actionsOnResponsiveMobile()">
            <i class="nav-icon bi bi-file-earmark"></i>
            <span class="nav-text">No Penal</span>
          </a>
        </li>
        <li *showForPermissions="['antecedente_no_inhabilitacion_access']" class="nav-item">
          <a routerLink="/antecedente/no-inhabilitacion" routerLinkActive="active" [routerLinkActiveOptions]="{ exact: true }" class="nav-link" (click)="actionsOnResponsiveMobile()">
            <i class="nav-icon bi bi-file-earmark"></i>
            <span class="nav-text">No Inhabilitación</span>
          </a>
        </li>
        <li *showForPermissions="['antecedente_federal_access']" class="nav-item">
          <a routerLink="/antecedente/federal" routerLinkActive="active" [routerLinkActiveOptions]="{ exact: true }" class="nav-link" (click)="actionsOnResponsiveMobile()">
            <i class="nav-icon bi bi-file-earmark"></i>
            <span class="nav-text">Federal</span>
          </a>
        </li>
      </ul>
    </nav> -->

    <nav
      *showForPermissions="['registro_civil_marco_folio_reverso_access', 'registro_civil_buscar_acto_access', 'registro_civil_digitalizacion_access', 'registro_civil_correccion_acta_access']"
      class="mb-4"
    >
      <p class="nav-title mb-2">Registro Civil</p>

      <ul class="nav-menu list-unstyled m-0">
        <li *showForPermissions="['registro_civil_buscar_acto_access']" class="nav-item">
          <a routerLink="/registro-civil/buscar-acto" routerLinkActive="active" [routerLinkActiveOptions]="{ exact: true }" class="nav-link" (click)="actionsOnResponsiveMobile()">
            <i class="nav-icon bi bi-file-earmark"></i>
            <span class="nav-text">Buscar acto</span>
          </a>
        </li>
        <li *showForPermissions="['registro_civil_marco_folio_reverso_access']" class="nav-item">
          <a routerLink="/registro-civil/marco-folio-reverso" routerLinkActive="active" [routerLinkActiveOptions]="{ exact: true }" class="nav-link" (click)="actionsOnResponsiveMobile()">
            <i class="nav-icon bi bi-file-earmark"></i>
            <span class="nav-text">Marcos, folios, reversos</span>
          </a>
        </li>
        <li *showForPermissions="['registro_civil_digitalizacion_access']" class="nav-item">
          <a routerLink="/registro-civil/digitalizacion" routerLinkActive="active" [routerLinkActiveOptions]="{ exact: true }" class="nav-link" (click)="actionsOnResponsiveMobile()">
            <i class="nav-icon bi bi-file-earmark"></i>
            <span class="nav-text">Digitalización</span>
          </a>
        </li>
        <li *showForPermissions="['registro_civil_correccion_acta_access']" class="nav-item">
          <a routerLink="/registro-civil/correccion-acta" routerLinkActive="active" [routerLinkActiveOptions]="{ exact: true }" class="nav-link" (click)="actionsOnResponsiveMobile()">
            <i class="nav-icon bi bi-file-earmark"></i>
            <span class="nav-text">Corrección de acta</span>
          </a>
        </li>
      </ul>
    </nav>

    <nav
      *showForPermissions="[
        'sat_cambio_emision_access',
        'sat_constancia_situacion_fiscal_access',
        'sat_opinion_cumplimiento_access',
        'sat_cedula_identificacion_fiscal_access',
        'sat_recuperacion_cfdi_access',
        'sat_recuperacion_declaracion_access',
        'sat_cita_persona_fisica_access',
        'sat_alta_rfc_primera_vez_con_contrasena_access',
        'sat_contrasena_ciec_ine_access',
      ]"
      class="mb-4"
    >
      <p class="nav-title mb-2">SAT</p>

      <ul class="nav-menu list-unstyled m-0">
        <li *showForPermissions="['sat_cambio_emision_access']" class="nav-item">
          <a routerLink="/sat/cambio-emision" routerLinkActive="active" [routerLinkActiveOptions]="{ exact: true }" class="nav-link" (click)="actionsOnResponsiveMobile()">
            <i class="nav-icon bi bi-file-earmark"></i>
            <span class="nav-text">Cambio de emisión</span>
          </a>
        </li>
        <li *showForPermissions="['sat_constancia_situacion_fiscal_access']" class="nav-item">
          <a routerLink="/sat/constancia-situacion-fiscal" routerLinkActive="active" [routerLinkActiveOptions]="{ exact: true }" class="nav-link" (click)="actionsOnResponsiveMobile()">
            <i class="nav-icon bi bi-file-earmark"></i>
            <span class="nav-text">Constancia de situación fiscal</span>
          </a>
        </li>
        <li *showForPermissions="['sat_opinion_cumplimiento_access']" class="nav-item">
          <a routerLink="/sat/opinion-cumplimiento" routerLinkActive="active" [routerLinkActiveOptions]="{ exact: true }" class="nav-link" (click)="actionsOnResponsiveMobile()">
            <i class="nav-icon bi bi-file-earmark"></i>
            <span class="nav-text">Opinión del cumplimiento</span>
          </a>
        </li>
        <li *showForPermissions="['sat_cedula_identificacion_fiscal_access']" class="nav-item">
          <a routerLink="/sat/cedula-identificacion-fiscal" routerLinkActive="active" [routerLinkActiveOptions]="{ exact: true }" class="nav-link" (click)="actionsOnResponsiveMobile()">
            <i class="nav-icon bi bi-file-earmark"></i>
            <span class="nav-text">Cédula de identificación fiscal</span>
          </a>
        </li>
        <li *showForPermissions="['sat_recuperacion_cfdi_access']" class="nav-item">
          <a routerLink="/sat/recuperacion-cfdi" routerLinkActive="active" [routerLinkActiveOptions]="{ exact: true }" class="nav-link" (click)="actionsOnResponsiveMobile()">
            <i class="nav-icon bi bi-file-earmark"></i>
            <span class="nav-text">Recuperación de CFDI</span>
          </a>
        </li>
        <li *showForPermissions="['sat_recuperacion_declaracion_access']" class="nav-item">
          <a routerLink="/sat/recuperacion-declaracion" routerLinkActive="active" [routerLinkActiveOptions]="{ exact: true }" class="nav-link" (click)="actionsOnResponsiveMobile()">
            <i class="nav-icon bi bi-file-earmark"></i>
            <span class="nav-text">Recuperación de declaración</span>
          </a>
        </li>
        <li *showForPermissions="['sat_cita_persona_fisica_access']" class="nav-item">
          <a routerLink="/sat/cita-persona-fisica" routerLinkActive="active" [routerLinkActiveOptions]="{ exact: true }" class="nav-link" (click)="actionsOnResponsiveMobile()">
            <i class="nav-icon bi bi-file-earmark"></i>
            <span class="nav-text">Cita para persona física</span>
          </a>
        </li>
        <li *showForPermissions="['sat_cita_persona_moral_access']" class="nav-item">
          <a routerLink="/sat/cita-persona-moral" routerLinkActive="active" [routerLinkActiveOptions]="{ exact: true }" class="nav-link" (click)="actionsOnResponsiveMobile()">
            <i class="nav-icon bi bi-file-earmark"></i>
            <span class="nav-text">Cita para persona moral</span>
          </a>
        </li>
        <li *showForPermissions="['sat_alta_rfc_primera_vez_con_contrasena_access']" class="nav-item">
          <a routerLink="/sat/alta-rfc-primera-vez-con-contrasena" routerLinkActive="active" [routerLinkActiveOptions]="{ exact: true }" class="nav-link" (click)="actionsOnResponsiveMobile()">
            <i class="nav-icon bi bi-file-earmark"></i>
            <span class="nav-text">Alta RFC por primera vez con contraseña</span>
          </a>
        </li>
        <li *showForPermissions="['sat_alta_rfc_primera_vez_sin_contrasena_access']" class="nav-item">
          <a routerLink="/sat/alta-rfc-primera-vez-sin-contrasena" routerLinkActive="active" [routerLinkActiveOptions]="{ exact: true }" class="nav-link" (click)="actionsOnResponsiveMobile()">
            <i class="nav-icon bi bi-file-earmark"></i>
            <span class="nav-text">Alta RFC por primera vez sin contraseña</span>
          </a>
        </li>
        <li *showForPermissions="['sat_contrasena_ciec_ine_access']" class="nav-item">
          <a routerLink="/sat/contrasena-ciec-ine" routerLinkActive="active" [routerLinkActiveOptions]="{ exact: true }" class="nav-link" (click)="actionsOnResponsiveMobile()">
            <i class="nav-icon bi bi-file-earmark"></i>
            <span class="nav-text">Contraseña CIEC con INE</span>
          </a>
        </li>
        <li *showForPermissions="['sat_restablecer_contrasena_access']" class="nav-item">
          <a routerLink="/sat/restablecer-contrasena" routerLinkActive="active" [routerLinkActiveOptions]="{ exact: true }" class="nav-link" (click)="actionsOnResponsiveMobile()">
            <i class="nav-icon bi bi-file-earmark"></i>
            <span class="nav-text">Restablecer contraseña</span>
            <p-tag [style]="{ border: '1px solid #4caf50', padding: '0px', gap: '0', background: 'transparent', color: '#4caf50' }">
              <div class="flex items-center gap-0 px-1">
                <span class="text-base font-light text-uppercase" style="font-size: 9px">Nuevo</span>
              </div>
            </p-tag>
          </a>
        </li>
      </ul>
    </nav>

    <nav *showForPermissions="['imss_consultar_nss_access', 'imss_informacion_nss_access', 'imss_semanas_cotizadas_access', 'imss_vigencia_derecho_access', 'imss_no_vigencia_access']" class="mb-4">
      <p class="nav-title mb-2">IMSS</p>

      <ul class="nav-menu list-unstyled m-0">
        <li *showForPermissions="['imss_informacion_nss_access']" class="nav-item">
          <a routerLink="/imss/informacion-nss" routerLinkActive="active" [routerLinkActiveOptions]="{ exact: true }" class="nav-link" (click)="actionsOnResponsiveMobile()">
            <i class="nav-icon bi bi-file-earmark"></i>
            <span class="nav-text">Información NSS</span>
            <p-tag [style]="{ border: '1px solid #4caf50', padding: '0px', gap: '0', background: 'transparent', color: '#4caf50' }">
              <div class="flex items-center gap-0 px-1">
                <span class="text-base font-light text-uppercase" style="font-size: 9px">Nuevo</span>
              </div>
            </p-tag>
          </a>
        </li>
        <li *showForPermissions="['imss_consultar_nss_access']" class="nav-item">
          <a routerLink="/imss/consultar-nss" routerLinkActive="active" [routerLinkActiveOptions]="{ exact: true }" class="nav-link" (click)="actionsOnResponsiveMobile()">
            <i class="nav-icon bi bi-file-earmark"></i>
            <span class="nav-text">Consultar NSS</span>
            <p-tag [style]="{ border: '1px solid #4caf50', padding: '0px', gap: '0', background: 'transparent', color: '#4caf50' }">
              <div class="flex items-center gap-0 px-1">
                <span class="text-base font-light text-uppercase" style="font-size: 9px">Nuevo</span>
              </div>
            </p-tag>
          </a>
        </li>
        <li *showForPermissions="['imss_asignar_correo_nss_access']" class="nav-item">
          <a routerLink="/imss/asignar-correo-nss" routerLinkActive="active" [routerLinkActiveOptions]="{ exact: true }" class="nav-link" (click)="actionsOnResponsiveMobile()">
            <i class="nav-icon bi bi-file-earmark"></i>
            <span class="nav-text">Asignar correo electrónico a NSS</span>
            <p-tag [style]="{ border: '1px solid #4caf50', padding: '0px', gap: '0', background: 'transparent', color: '#4caf50' }">
              <div class="flex items-center gap-0 px-1">
                <span class="text-base font-light text-uppercase" style="font-size: 9px">Nuevo</span>
              </div>
            </p-tag>
          </a>
        </li>
        <li *showForPermissions="['imss_semanas_cotizadas_access']" class="nav-item">
          <a routerLink="/imss/semanas-cotizadas" routerLinkActive="active" [routerLinkActiveOptions]="{ exact: true }" class="nav-link" (click)="actionsOnResponsiveMobile()">
            <i class="nav-icon bi bi-file-earmark"></i>
            <span class="nav-text">Semanas cotizadas</span>
            <p-tag [style]="{ border: '1px solid #4caf50', padding: '0px', gap: '0', background: 'transparent', color: '#4caf50' }">
              <div class="flex items-center gap-0 px-1">
                <span class="text-base font-light text-uppercase" style="font-size: 9px">Nuevo</span>
              </div>
            </p-tag>
          </a>
        </li>
        <li *showForPermissions="['imss_vigencia_derecho_access']" class="nav-item">
          <a routerLink="/imss/vigencia-derecho" routerLinkActive="active" [routerLinkActiveOptions]="{ exact: true }" class="nav-link" (click)="actionsOnResponsiveMobile()">
            <i class="nav-icon bi bi-file-earmark"></i>
            <span class="nav-text">Vigencia de derecho</span>
            <p-tag [style]="{ border: '1px solid #4caf50', padding: '0px', gap: '0', background: 'transparent', color: '#4caf50' }">
              <div class="flex items-center gap-0 px-1">
                <span class="text-base font-light text-uppercase" style="font-size: 9px">Nuevo</span>
              </div>
            </p-tag>
          </a>
        </li>
        <li *showForPermissions="['imss_no_derechohabiente_access']" class="nav-item">
          <a routerLink="/imss/no-derechohabiente" routerLinkActive="active" [routerLinkActiveOptions]="{ exact: true }" class="nav-link" (click)="actionsOnResponsiveMobile()">
            <i class="nav-icon bi bi-file-earmark"></i>
            <span class="nav-text">No derechohabiente</span>
            <p-tag [style]="{ border: '1px solid #4caf50', padding: '0px', gap: '0', background: 'transparent', color: '#4caf50' }">
              <div class="flex items-center gap-0 px-1">
                <span class="text-base font-light text-uppercase" style="font-size: 9px">Nuevo</span>
              </div>
            </p-tag>
          </a>
        </li>
      </ul>
    </nav>

    <nav *showForPermissions="['renapo_correccion_curp_access', 'renapo_unificacion_curp_access', 'renapo_certificacion_curp_access']" class="mb-4">
      <p class="nav-title mb-2">RENAPO</p>

      <ul class="nav-menu list-unstyled m-0">
        <li *showForPermissions="['renapo_curp_access']" class="nav-item">
          <a routerLink="/renapo/curp" routerLinkActive="active" [routerLinkActiveOptions]="{ exact: true }" class="nav-link" (click)="actionsOnResponsiveMobile()">
            <i class="nav-icon bi bi-file-earmark"></i>
            <span class="nav-text">CURP</span>
          </a>
        </li>
        <li *showForPermissions="['renapo_correccion_curp_access']" class="nav-item">
          <a routerLink="/renapo/correccion-curp" routerLinkActive="active" [routerLinkActiveOptions]="{ exact: true }" class="nav-link" (click)="actionsOnResponsiveMobile()">
            <i class="nav-icon bi bi-file-earmark"></i>
            <span class="nav-text">Corrección de CURP</span>
          </a>
        </li>
        <li *showForPermissions="['renapo_unificacion_curp_access']" class="nav-item">
          <a routerLink="/renapo/unificacion-curp" routerLinkActive="active" [routerLinkActiveOptions]="{ exact: true }" class="nav-link" (click)="actionsOnResponsiveMobile()">
            <i class="nav-icon bi bi-file-earmark"></i>
            <span class="nav-text">Unificación de CURP</span>
          </a>
        </li>
        <li *showForPermissions="['renapo_certificacion_curp_access']" class="nav-item">
          <a routerLink="/renapo/certificacion-curp" routerLinkActive="active" [routerLinkActiveOptions]="{ exact: true }" class="nav-link" (click)="actionsOnResponsiveMobile()">
            <i class="nav-icon bi bi-file-earmark"></i>
            <span class="nav-text">Certificación de CURP</span>
          </a>
        </li>
      </ul>
    </nav>

    <nav *showForPermissions="['issste_talon_pagos_access']" class="mb-4">
      <p class="nav-title mb-2">ISSSTE</p>

      <ul class="nav-menu list-unstyled m-0">
        <li *showForPermissions="['issste_talon_pagos_access']" class="nav-item">
          <a routerLink="/issste/talon-pagos" routerLinkActive="active" [routerLinkActiveOptions]="{ exact: true }" class="nav-link" (click)="actionsOnResponsiveMobile()">
            <i class="nav-icon bi bi-file-earmark"></i>
            <span class="nav-text">Talón de Pagos</span>
          </a>
        </li>
        <li *showForPermissions="['issste_constancia_acreditacion_no_afiliacion_access']" class="nav-item">
          <a routerLink="/issste/constancia-acreditacion-no-afiliacion" routerLinkActive="active" [routerLinkActiveOptions]="{ exact: true }" class="nav-link" (click)="actionsOnResponsiveMobile()">
            <i class="nav-icon bi bi-file-earmark"></i>
            <span class="nav-text">Constancia de acreditación de no afiliación</span>
          </a>
        </li>
      </ul>
    </nav>

    <nav *showForPermissions="['cfe_recibo_de_luz_access']" class="mb-4">
      <p class="nav-title mb-2">CFE</p>

      <ul class="nav-menu list-unstyled m-0">
        <li *showForPermissions="['cfe_recibo_de_luz_access']" class="nav-item">
          <a routerLink="/cfe/recibo-de-luz" routerLinkActive="active" [routerLinkActiveOptions]="{ exact: true }" class="nav-link" (click)="actionsOnResponsiveMobile()">
            <i class="nav-icon bi bi-file-earmark"></i>
            <span class="nav-text">Recibo de Luz</span>
            <p-tag [style]="{ border: '1px solid #4caf50', padding: '0px', gap: '0', background: 'transparent', color: '#4caf50' }">
              <div class="flex items-center gap-0 px-1">
                <span class="text-base font-light text-uppercase" style="font-size: 9px">Nuevo</span>
              </div>
            </p-tag>
          </a>
        </li>
      </ul>
    </nav>
  </main>

  <footer class="border-top">
    <a class="nav-link w-100" (click)="lockscreen(); actionsOnResponsiveMobile()"> <i class="nav-icon bi bi-box-arrow-right"></i> Bloquear sesión </a>
  </footer>
</aside>
